import requestFlow from '@/utils/requestFlow'
import { fundingAppRoutine } from '@/store/routines'

export default {
  ...requestFlow(fundingAppRoutine).mockMutations
  // [fundingAppRoutine.SUCCESS] (state, payload) {
  //   state.auth.user.fundingApplicationId = payload.fundingApplicationId
  // }
}
